<div class="container">
	<div class="d-flex justify-content-center h-100">
		<div class="card">
            <div class="card-header">
				<h3>Reset Your Password</h3>
			</div>
			<div class="card-body">
                <div class="subtitle">
                    <p class="text-center">Please enter your email address to request a password reset.</p>
                  </div>

					<div class="input-group form-group">
						<input type="email" class="form-control" placeholder="Email Address" #passwordResetEmail required>
					</div>
					<div class="form-group">
						<input type="submit" value="Reset Password" class="btn btn-block login_btn" (click)="authService.forgotPassword(passwordResetEmail.value)">
					</div>
			</div>
			<div class="card-footer">
				<div class="d-flex justify-content-center links">
					<span>Go back to?<a routerLink="/login"> Sign in</a></span>
				</div>
			</div>
		</div>
	</div>
</div>

